/* eslint-disable max-len */
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListSectionDesktopTabletComponent } from './list-section/desktop-tablet/list-section-desktop-tablet.component';
import { ListSectionMobileComponent } from './list-section/mobile/list-section-mobile.component';
import { ListDetailManagementResolverService } from './list-detail-management/services/list-detail-management-resolver.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateListDesktopComponent } from './create-list/create-list-desktop/create-list-desktop.component';
import { CreateListTouchComponent } from './create-list/create-list-touch/create-list-touch.component';
import { CreateListInputComponent } from './create-list/create-list-touch/create-list-input/create-list-input.component';
import { IonNav } from '@ionic/angular';
import { SelectedProductsDesktopTabletComponent } from './selected-products/selected-products-desktop-tablet/selected-products-desktop-tablet.component';
import { SelectedProductsMobileComponent } from './selected-products/selected-products-mobile/selected-products-mobile.component';
import { SelectedProductsInputComponent } from './selected-products/selected-products-mobile/selected-products-input/selected-products-input.component';
import { ListBannerComponent } from './list-banner/list-banner.component';
import { EditNameComponent } from './edit-list-group-name/edit-name.component';
import { CreateGroupComponent } from './create-group/create-group.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { DeleteListComponent } from './delete-list/delete-list.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SortFilterListDesktopTabletComponent } from './sort-filter-list/sort-filter-list-desktop-tablet/sort-filter-list-desktop-tablet.component';
import { SortFilterListMobileComponent } from './sort-filter-list/sort-filter-list-mobile/sort-filter-list-mobile.component';
import { SortFilterListInputComponent } from './sort-filter-list/sort-filter-list-mobile/sort-filter-list-input/sort-filter-list-input.component';
import { VendorsMobileSortComponent } from '../../inventory/pages/manage-vendors/components/vendors-mobile-sort/vendors-mobile-sort.component';
import { CreateEditNonUsfVendorInputComponent } from '../../inventory/pages/manage-vendors/components/create-edit-non-usf-vendor/create-edit-non-usf-vendor-input/create-edit-non-usf-vendor-input.component';
import { CreateEditNonUsfVendorComponent } from '../../inventory/pages/manage-vendors/components/create-edit-non-usf-vendor/create-edit-non-usf-vendor.component';
import { ManageVendorsStickyFooterComponent } from '../../inventory/pages/manage-vendors/components/manage-vendors-sticky-footer/manage-vendors-sticky-footer.component';
import { ListGroupsDesktopTabletComponent } from './list-groups/desktop-tablet/list-groups-desktop-tablet.component';
import { ListGroupsMobileComponent } from './list-groups/mobile/list-groups-mobile.component';
import { GroupProductListDesktopComponent } from '../components/group-product-list/group-product-list-desktop/group-product-list-desktop.component';
import { GroupProductListTouchComponent } from '../components/group-product-list/group-product-list-touch/group-product-list-touch.component';
import { NoProductsInGroupComponent } from '../components/no-products-in-group/no-products-in-group.component';
import { ListNoteModalComponent } from '../components/list-note-modal/list-note-modal.component';
import { DownloadListV2Component } from './download-list-v2/download-list-v2.component';
import { CopyListModalDesktopComponent } from '../components/copy-list-modal/copy-list-desktop-modal/copy-list-modal-desktop-component';
import { CopyListModalTouchComponent } from '../components/copy-list-modal/copy-list-touch-modal/copy-list-modal-touch-component';
import { CopyListInputComponent } from '../components/copy-list-modal/copy-list-touch-modal/copy-list-input/copy-list-input-component';
import { ListLandingSkeletonComponent } from '../components/list-landing-skeleton/list-landing-skeleton.component';
import { ListManagementSkeletonComponent } from '../components/list-management-skeleton/list-management-skeleton.component';
import { ImportErrorToastComponent } from './import-error-toast/import-error-toast.component';
import { ImportErrorModalComponent } from './import-error-modal/import-error-modal.component';
import { SortAndFilterButtonComponent } from './sort-and-filter-button/sort-and-filter-button.component';
import { DeleteListSummaryModalComponent } from './delete-list-summary-modal/delete-list-summary-modal.component';
import { ImportListModalContainerComponent } from '../components/import-list-modal-container/import-list-modal-container.component';
import { CopyProductsModalContainerComponent } from '../components/copy-products-modal-container/copy-products-modal-container.component';
import { CopyProductsModalComponent } from '../components/copy-products-modal/copy-products-modal.component';
import { CopyToListsModalComponent } from '../components/copy-to-lists-modal/copy-to-lists-modal.component';
import { CopyToGroupsModalComponent } from '../components/copy-to-groups-modal/copy-to-groups-modal.component';
import { GroupListInputComponent } from './selected-products/selected-products-mobile/group-list-input/group-list-input.component';
import { VerifyCopiedProductsModalComponent } from '../components/verify-copied-products-modal/verify-copied-products-modal.component';
import { ListDownloadContainerComponent } from './list-download-container/list-download-container.component';
import { ListPrintContainerComponent } from './list-print-container/list-print-container.component';
import { AiListBuilderModalComponent } from '../components/ai-list-builder-modal/ai-list-builder-modal.component';
import { AiListProductCardComponent } from '../components/ai-list-product-card/ai-list-product-card.component';
import { AiListIngredientMenuComponent } from '../components/ai-list-ingredient-menu/ai-list-ingredient-menu.component';
import { AiListIngredientMenuProductCardComponent } from '../components/ai-list-ingredient-menu-product-card/ai-list-ingredient-menu-product-card.component';
import { PriceModeSidebarComponent } from './price-mode-sidebar/price-mode-sidebar.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatCheckboxModule,
    DragDropModule,
  ],
  providers: [IonNav, DatePipe],
  declarations: [
    AiListBuilderModalComponent,
    AiListProductCardComponent,
    AiListIngredientMenuComponent,
    ListSectionDesktopTabletComponent,
    ListSectionMobileComponent,
    ListGroupsDesktopTabletComponent,
    ListGroupsMobileComponent,
    DeleteListSummaryModalComponent,
    CreateListDesktopComponent,
    CreateListTouchComponent,
    CreateListInputComponent,
    SelectedProductsDesktopTabletComponent,
    SelectedProductsMobileComponent,
    SelectedProductsInputComponent,
    ListBannerComponent,
    EditNameComponent,
    CreateGroupComponent,
    DeleteListComponent,
    SortFilterListDesktopTabletComponent,
    SortFilterListMobileComponent,
    SortFilterListInputComponent,
    VendorsMobileSortComponent,
    CreateEditNonUsfVendorComponent,
    CreateEditNonUsfVendorInputComponent,
    ManageVendorsStickyFooterComponent,
    DownloadListV2Component,
    GroupProductListDesktopComponent,
    GroupProductListTouchComponent,
    NoProductsInGroupComponent,
    ListNoteModalComponent,
    CopyListModalDesktopComponent,
    CopyListModalTouchComponent,
    CopyListInputComponent,
    CopyToListsModalComponent,
    ImportListModalContainerComponent,
    ListLandingSkeletonComponent,
    ListManagementSkeletonComponent,
    ImportErrorToastComponent,
    ImportErrorModalComponent,
    SortAndFilterButtonComponent,
    CopyProductsModalContainerComponent,
    CopyProductsModalComponent,
    CopyToGroupsModalComponent,
    GroupListInputComponent,
    VerifyCopiedProductsModalComponent,
    ListDownloadContainerComponent,
    ListPrintContainerComponent,
    AiListIngredientMenuProductCardComponent,
    PriceModeSidebarComponent,
  ],
  exports: [
    AiListBuilderModalComponent,
    AiListProductCardComponent,
    AiListIngredientMenuComponent,
    ListSectionDesktopTabletComponent,
    ListSectionMobileComponent,
    ListGroupsDesktopTabletComponent,
    ListGroupsMobileComponent,
    DeleteListSummaryModalComponent,
    CreateListDesktopComponent,
    CreateListTouchComponent,
    CreateListInputComponent,
    SelectedProductsDesktopTabletComponent,
    SelectedProductsMobileComponent,
    SelectedProductsInputComponent,
    ListBannerComponent,
    EditNameComponent,
    CreateGroupComponent,
    DeleteListComponent,
    SortFilterListDesktopTabletComponent,
    SortFilterListMobileComponent,
    SortFilterListInputComponent,
    VendorsMobileSortComponent,
    CreateEditNonUsfVendorComponent,
    CreateEditNonUsfVendorInputComponent,
    ManageVendorsStickyFooterComponent,
    DownloadListV2Component,
    GroupProductListDesktopComponent,
    GroupProductListTouchComponent,
    NoProductsInGroupComponent,
    ListNoteModalComponent,
    CopyListModalDesktopComponent,
    CopyListModalTouchComponent,
    CopyListInputComponent,
    CopyToListsModalComponent,
    ListLandingSkeletonComponent,
    ListManagementSkeletonComponent,
    ImportErrorModalComponent,
    ImportErrorToastComponent,
    ImportListModalContainerComponent,
    SortAndFilterButtonComponent,
    CopyProductsModalContainerComponent,
    CopyProductsModalComponent,
    CopyToGroupsModalComponent,
    GroupListInputComponent,
    VerifyCopiedProductsModalComponent,
    ListDownloadContainerComponent,
    ListPrintContainerComponent,
    AiListIngredientMenuProductCardComponent,
    PriceModeSidebarComponent,
  ],
})
export class ListSharedModule {}
